import {
  confirmAllBookingCancel,
  confirmDeleteChildCourse,
  confirmBulkDelete
} from './ConfirmMessageBoxes';
import { fiflboxApi } from '@/utils/api';
import _ from 'lodash';

export default {
  methods: {
    arrangeDataForPartialDeleteChildCourse() {
      let form = _.cloneDeep(this.data);
      form.parent_course = form.parent_course.id;
      form.recurrence = this.form.recurrence;
      form.start = form.dt;
      form.from_date = form.dt;
      return form;
    },
    async requestDeleteForm(isAllCourseDelete) {
      if (!isAllCourseDelete) {
        try {
          await fiflboxApi.v1.postCourseExclusions({
            dt: this.data.dt,
            child_course: this.form.id
          });
          return true;
        } catch (err) {
          return false;
        }
      }
      if (this.data.dt === this.data.start) {
        try {
          await fiflboxApi.v2.deleteChildCourses(this.form.id);
          return true;
        } catch (err) {
          return false;
        }
      }

      let form = this.arrangeDataForPartialDeleteChildCourse();
      try {
        form.is_delete = true;
        form.is_init = false;
        const response = await fiflboxApi.v2.putChildCourses(form.id, form);
        const exclusive_course_id = response.data;
        try {
          await fiflboxApi.v2.deleteChildCourses(exclusive_course_id);
        } catch (err) {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    },
    async deleteChildCourse() {
      let isRecurrence = this.recurrenceForm.frequency !== 0;
      let isDeleteChildCourse = await confirmDeleteChildCourse();

      if (!isDeleteChildCourse) {
        return false;
      }

      let { isBulkDelete, stopDelete } = await confirmBulkDelete(isRecurrence);

      if (stopDelete) {
        return false;
      }
      const bookings = await this.fetchBookings(
        this.data.id,
        this.data.dt,
        isBulkDelete
      );

      if (bookings.length > 0) {
        let isDeleteWithCancelBooking = await confirmAllBookingCancel(
          bookings,
          this.isBookingSystem,
          true
        );

        if (!isDeleteWithCancelBooking) {
          return false;
        }
      }
      const isDeleteSuccess = await this.requestDeleteForm(isBulkDelete);

      if (!isDeleteSuccess) {
        this.$message({
          type: 'success',
          message: '수업 삭제중 오류가 발생하였습니다.'
        });

        return false;
      }

      this.$message({
        type: 'success',
        message:
          isRecurrence && isBulkDelete
            ? '모든 수업이 삭제됐습니다.'
            : '수업이 삭제됐습니다.'
      });

      return true;
    }
  }
};
